export const isAuthenticated = () => {
    const authHeader = sessionStorage.getItem('authorization');
    const authRole = sessionStorage.getItem('role');
    if (!authHeader) return false;
    if (authRole !== 'admin') return false;
    else return true;
}
